import { render, staticRenderFns } from "./SearchCase.vue?vue&type=template&id=16d87253&scoped=true"
import script from "./SearchCase.vue?vue&type=script&lang=js"
export * from "./SearchCase.vue?vue&type=script&lang=js"
import style0 from "./SearchCase.vue?vue&type=style&index=0&id=16d87253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d87253",
  null
  
)

export default component.exports